import script from "./MessageBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageBox.vue?vue&type=script&setup=true&lang=ts"

import "./MessageBox.vue?vue&type=style&index=0&id=2f9ca9f6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f9ca9f6"]])

export default __exports__